export { useGetAnnotations } from '@dc-shared-web/hooks/api/annotations/useGetAnnotations'
export { useGetProvisionHighlights } from '@dc-shared-web/hooks/api/annotations/useGetProvisionHighlights'
export { useSaveAnnotations } from '@dc-shared-web/hooks/api/annotations/useSaveAnnotations'
export { fetchProvisionHighlights } from '@dc-shared-web/hooks/api/annotations/fetchProvisionHighlights'

export type * from '@dc-shared-web/hooks/api/annotations/types'
